// extracted by css-extract-rspack-plugin
export default {"HorizontalScrollBox":"JtYEG"};